import React from "react";
import siteConfig, { formatPrice } from "../config/siteConfig";
import "../css/delivery.scss";

function Delivery() {
  return (
    <main className="policy-page delivery-policy" aria-labelledby="delivery-title">
      <header className="policy-page__intro">
        <div className="policy-page__intro-inner">
          <p className="policy-page__kicker">Customer care / Orders</p>
          <h1 id="delivery-title">Shipping &amp; delivery</h1>
          <p className="policy-page__lead">
            Tracked delivery from our door to yours, with clear updates at every
            stage of the journey.
          </p>
          <p className="policy-page__updated">
            Complimentary standard UK shipping over {formatPrice(siteConfig.shippingThreshold)}.
          </p>
        </div>
      </header>

      <div className="policy-page__layout">
        <nav className="policy-page__contents" aria-label="Shipping information contents">
          <p>On this page</p>
          <a href="#delivery-options">Delivery options</a>
          <a href="#delivery-dispatch">Dispatch and tracking</a>
          <a href="#delivery-international">International orders</a>
          <a href="#delivery-delays">Delays and missing parcels</a>
          <a href="#delivery-contact">Contact us</a>
        </nav>

        <article className="policy-page__content">
          <section id="delivery-options">
            <p className="policy-page__section-number">01</p>
            <h2>Delivery options</h2>
            <div className="policy-page__table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Destination</th>
                    <th>Service</th>
                    <th>Estimated transit</th>
                    <th>Cost</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>United Kingdom</td>
                    <td>Tracked standard</td>
                    <td>2–4 working days</td>
                    <td>{formatPrice(siteConfig.standardShipping)}</td>
                  </tr>
                  <tr>
                    <td>United Kingdom</td>
                    <td>Tracked express</td>
                    <td>1–2 working days</td>
                    <td>Shown at checkout</td>
                  </tr>
                  <tr>
                    <td>Europe</td>
                    <td>Tracked international</td>
                    <td>3–8 working days</td>
                    <td>Shown at checkout</td>
                  </tr>
                  <tr>
                    <td>Rest of world</td>
                    <td>Tracked international</td>
                    <td>5–12 working days</td>
                    <td>Shown at checkout</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="policy-page__fine-print">
              Estimates begin once an order has been dispatched and exclude public
              holidays, customs processing and remote-area surcharges.
            </p>
          </section>

          <section id="delivery-dispatch">
            <p className="policy-page__section-number">02</p>
            <h2>Dispatch and tracking</h2>
            <p>
              We inspect and pack orders during working hours. Once your parcel is
              collected, we will email a tracking link. Tracking can take several
              hours to update after the carrier scans the parcel.
            </p>
          </section>

          <section id="delivery-international">
            <p className="policy-page__section-number">03</p>
            <h2>International orders</h2>
            <p>
              Local duties, taxes and customs fees may be collected by the
              destination country and are the recipient's responsibility unless the
              checkout explicitly states otherwise. Customs checks can add time
              beyond the quoted estimate.
            </p>
          </section>

          <section id="delivery-delays">
            <p className="policy-page__section-number">04</p>
            <h2>Delays and missing parcels</h2>
            <p>
              Check the tracking link and delivery address first. If there has been
              no movement for several working days, contact us with your order
              number so we can open an enquiry with the carrier.
            </p>
          </section>

          <section id="delivery-contact" className="policy-page__callout">
            <p className="policy-page__section-number">05</p>
            <h2>Need help with a delivery?</h2>
            <p>
              Email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>{" "}
              with your order number and postcode so we can investigate quickly.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}

export default Delivery;
